$(document).ready(function(e) {
  
  $('#cartform').on('submit',function(e){
    if (!$('#tandc').is(':checked')) {
      e.preventDefault();
      alert('Acepto el tratamiento de mis datos personales de acuerdo con la Política de Privacidad de Datos Personales de Pernine Ltda.');
    }
  });
  
  function updateInputPlaceholder(){
    if(Weglot.getCurrentLang() == 'en'){
      $('.SearchForm input').attr('placeholder', 'Search');
    } else {
      $('.SearchForm input').attr('placeholder', 'Buscar');
    }
  }
  if(typeof Weglot !== 'undefined') {
    Weglot.on("switchersReady", function(){ updateInputPlaceholder(); });
    Weglot.on("languageChanged", function(){ updateInputPlaceholder(); });
  }
  function closePopup() {
    $('.popupBox').removeClass('fadeInUp');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
    $('.cls_popup').remove();
    $('body').removeClass('popupOpned');
    
    if($('#manvideo').length) {
      $('#manvideo')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');   
    }
  }
  function openPopup(a) {
    $('.popupBox').addClass('fadeInUp');
    $('.popupBox').removeClass('slideOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
    $('body').addClass('popupOpned');
    $('.popupBox').append('<a class="cls_popup" ></a>');
  }

  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }  
  }
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });

  $('.topbarPoupOpen').on('click', function(e){
    e.preventDefault();
    openPopup('topbarShipping');
  });


  $('.shippingInfoPopup').on('click', function(e){
    e.preventDefault();
    openPopup('smpassMoreInfo');
  });
  
  $('.afterpayLink').on('click', function(e){
    e.preventDefault();
    openPopup('afterpayPopup');
  });
  
  

  function refreshHeigh() {
    var bh = $('.cartButtonOuter').height()+85;
    var vh = window.innerHeight;
    var newh = vh-bh;
    var qih = $('.quick-items').height();
    $('.cartDrawer').removeClass('nofix');
    $('.quick-items').removeAttr('style');
    if(newh > 115) { // 115 is one line-item height in cart 
      if(qih > newh) {
        $('.quick-items').css('max-height',newh+'px').css('overflow-y','scroll');
      }
    }
    else {
      $('.cartDrawer').addClass('nofix');
    }
  }

  refreshHeigh();

  $(window).resize(function(){
    setTimeout(function() {
      refreshHeigh();
      $('.cartDrawer').css("height", window.innerHeight+'px');
    }, 50); 
  });

  $('.dropdownmenu').each(function(){
    var lp = $(this).offset().left;
    if(lp < 0) {
      $(this).parent().addClass('rmPosRel');
    }
  });
  $('.hasDropDown').hover(function(){
    var d = $(this).find('.dropdownmenu');
    if(d.length) {
      var lp = d.offset().left;
      if(lp < 0) {
        $(this).addClass('pushtoLeft');
      } else {
        $(this).removeClass('pushtoLeft');
      }
      var rp = ($(window).width() - (d.offset().left + d.outerWidth()));
      if(rp < 0) {
        $(this).addClass('pushtoRight');
      } else {
        $(this).removeClass('pushtoRight');
      }
    }
  });

  $('.mobileNav').on('click',function(e){
    e.preventDefault();
    if($(this).parents('.fullPage').hasClass('witmenu')){
      setTimeout(function(){
      $('body').removeClass('menuOpen');
      $('.fullPage').removeClass('witmenu');
    }, 100);
    }else{
      if ($('#shopify-section-announcement-banner').length > 0){
        var h = $('#shopify-section-announcement-banner').outerHeight() + $('#shopify-section-header').outerHeight() + 'px';
        $('.mobileMenu').css('top',h);
      } else {
        var h = $('#shopify-section-header').outerHeight() + 'px';
        $('.mobileMenu').css('top',h);
      }
     setTimeout(function(){
        $('body').addClass('menuOpen');
        $('.fullPage').addClass('witmenu');
      }, 100);
    }
  });


 $(".hasDropDown").hover(
  function () {
    $('html').addClass("overflow_class");
  },
  function () {
    $('html').removeClass("overflow_class");
  }
);
 function bodyfunction(){
    if ($window.width() > 992) {
      $('html').addClass("overflow_class");
    } else {
      $('html').removeClass("overflow_class");
    }
  };
  window.onload = function(){
    bodyfunction();
  }
  $(window).resize(function(){
    bodyfunction();
  });
  
  $('.filterToggle').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('filterOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });
  
   $('#mainNavMob').on('click','.toggleItem',function(e){
    $('.mobileMenu').addClass('mobfoxheight');
    $('.mobileMenu')[0].scrollTop = 0;
    if($(this).hasClass('opend')) {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
    } else {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
      $(this).addClass('opend');
      $(this).parent().next('ul').addClass('toggleSubMenu');
    }
  });
  
  $('#mainNavMob').on('click','.backTitle',function(e){
    $('.toggleItem').removeClass('opend');
    $('.dropdownmenu').addClass('hideToggleMenu');
    setTimeout(function(){
      $('.dropdownmenu').removeClass('toggleSubMenu').removeClass('hideToggleMenu');
    },500);
    $('.mobileMenu').removeClass('mobfoxheight');
  });
  
  $('#mainNavMob').on('click','.col_menu_only .menu_only_title',function(e){
    var h = $(this).closest('ul')[0].scrollHeight;
    $(this).closest('ul')[0].scrollTop = 0;
    $(this).closest('ul').css('overflow','hidden');
    $(this).next('ul').addClass('menu_step3'); //.css('min-height',h+'px');
  });
  
  $('#mainNavMob').on('click','.backTitle3',function(e){
    var btn = $(this);
    btn.closest('.toggleSubMenu').removeAttr('style');
    btn.closest('ul').addClass('hidemenu_step3');
    setTimeout(function(){
      btn.closest('ul').removeClass('menu_step3').removeClass('hidemenu_step3');
    },500);
  });
  
  $('body').on('click','.fullPage.witmenu, .closemenu, .closecart', function(e){
    if($(this).closest('.colSidebar').length) {
      return false;
    }
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });
  
  $('.menu-overlay').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });
  
  
  
  $('.mobToggler').on('click',function(e){
    $(this).next('div').slideToggle();
    $(this).toggleClass('opned');
  });
  

  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
      
      setTimeout(function() {
        refreshHeigh();
        $('.cartDrawer').css("height", window.innerHeight+'px');
      }, 100); 
      //Currency.convertAll(shopCurrency, $('.currentCurreny > span').text());
      //jQuery('.currentCurreny > span').text(Currency.currentCurrency); 
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    });
  }

  $('.cartOuter').on('mouseenter, click',function(e){
    if($(this).find('.cartCount').text()!="0") {
      //addToCartSuccess();
      e.preventDefault();
      setTimeout(function(){
        $('body').addClass('cartOpen');
        $('.fullPage').addClass('witmenu');
      }, 50);
    }
  });
  

   
  $('.cartCount').on("DOMSubtreeModified",function(){
    addToCartSuccess();
  });
  
  

  $('body').on('click','.addtocart',function(e){
    e.preventDefault();
    var btn = $(this);
    if(typeof Weglot !== 'undefined') {
      var btnText = (Weglot.getCurrentLang() == 'en') ? 'Add to cart' : 'Añadir al carrito';
      btn.val((Weglot.getCurrentLang() == 'en') ? 'Adding...' : 'Agregando...');
    } else {
      var btnText = 'Añadir al carrito';
      btn.val('Agregando...');
    }
    
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        if(jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        }
        btn.val(btnText);
        btn.removeAttr('disabled');
      },
      success: function(product){
        dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'currencyCode': 'AUD',
            'add': {                                // 'add' actionFieldObject measures.
              'products': [{                        //  adding a product to a shopping cart.
                'name': product.product_title,           // Name or ID is required.
                'id': product.id,
                'price': product.price/100,
                'brand': 'Steve Madden',
                'variant': product.variant_title,
                'category': form.attr('data-category'),
                'quantity': product.quantity
              }]
            }
          }
        });
      }
    }).done(function( data ) {
      //addToCartSuccess();
      btn.val(btnText);
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(c){
        $('.cartCount').text(c.item_count);
      });
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    });

  });

  $("#crt").on('click', "a.remove_item", function(r){
    var ix = $(this);
    dataLayer.push({
      'event': 'removeFromCart',
      'ecommerce': {
        'remove': {                               // 'remove' actionFieldObject measures.
          'products': [{                          //  removing a product from a shopping cart.
            'name': ix.attr('data-name'),             // Name or ID is required.
            'id': ix.attr('data-pid'),
            'price': ix.attr('data-price'),
            'brand': 'Steve Madden',
            'category': ix.attr('data-category'),
            'variant': ix.attr('data-variant'),
            'quantity': ix.attr('data-quantity'),
          }]
        }
      }
    });
    
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount, .cartCount').text(c.item_count);
      if(!c.item_count) {
        $('.itemCount').text('0');
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
      }/* else {
        addToCartSuccess();
      }*/
    });
  });

  $('body').on('click', '.quick-cart-details .adjust',function(){

    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);


    $('#crt').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      },
      success: function(){
        //addToCartSuccess();
        $.getJSON('/cart.js', function(c){
          $('.itemCount, .cartCount').text(c.item_count);
        });
        $('#crt').removeClass('loading');
      }
    });

  });

  $('.item-quantityg').keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

  $('.tablist ul li').click(function(e){
    e.preventDefault();
    $('.tablist ul li').removeClass('activetab');
    $('.relatedProductC').hide();
    var currenTab = $(this).data('id');
    $(this).addClass('activetab');
    $('#'+currenTab).show();
    //var x = $(this).attr('data-slick');
    if($('.responsive').hasClass('slick-initialized')) {
      $('.responsive').slick('refresh');
    }
  });


  $('.responsive').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  if($('#myVideo').length) {
    document.getElementById("myVideo").pause();
  }
  $(".fancybox_viral").click(function(event){
    event.preventDefault();
    document.getElementById("myVideo").play();
    $('.viralsweep_popup').addClass('open_viralpopup');
    $('body').addClass('open_viralpopupbody');
    $('html').addClass('open_viralpopuphtml');
  });
  $(".inner_viral_close").click(function(event){		
    event.preventDefault();
    document.getElementById("myVideo").pause();
    $('.viralsweep_popup').removeClass('open_viralpopup');
    $('body').removeClass('open_viralpopupbody');
    $('html').removeClass('open_viralpopuphtml');
  });
   
  var baseURL = "https://services.superga-usa.com/";
  $('.mainNewsletter').on('submit',function(e){
    // This prevents the form from submitting
    e.preventDefault();    
    var x = true;
    $('.err-msg').hide();
//     debugger;
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().find('.err-msg').show();
      x = false;
    } else {
      em.parent().find('.err-msg').hide();
    }

    if(x){
      $.ajax({
        type: "POST",
        url: baseURL + 'Responsys/AddNewsLetter',
        data: "email="+email+"&page=PopUp",
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span class='successMsg'>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
          $('.nlMore input[type="email"]').val(email);
          //openPopup('nlMsg');
        },
        error: function (e) {
          //debugger;
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });
  
  
  $('#moreAboutYou').on('submit',function(e){
    e.preventDefault();    
    var x = true;
    $('.err-msg').remove();
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.parent().find('.err-msg').remove();
    }
    
    if($('#agreementSMPass:checked').length) {
      var pc = form.find("input[name='pcode']");
      if(pc.val().trim() == '') {
        pc.parent().append('<p class="err-msg">Please enter Postal code.</p>');
        x = false;
      } else {
        pc.parent().find('.err-msg').remove();
      }
      
      var tp = form.find("input[name='telephone']");
      if(tp.val().trim() == '') {
        tp.parent().append('<p class="err-msg">Please enter Telephone.</p>');
        x = false;
      } else {
        tp.parent().find('.err-msg').remove();
      }
    }

    if(x){
      var mydata={
        email: email,
        page:"Footer"
      };
      $.ajax({
        type: "POST",
        url: baseURL + '*********',
        data: mydata,
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
           
        },
        error: function (e) {
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });

 $('#shopify-section-footer a').each(function(){	
    if($(this).html() == 'Accessibility Toolbar'){	
      $(this).attr('id', 'accessibilityEnablerCustomTrigger');	
    }	
  });
  
  // Predictive search start
  $(document).on("click", function(e) {
     if(!$(e.target).hasClass("predictive-srch-right-wrapper") && !$(e.target).hasClass("predictive-srch-left-wrapper") && $(window).width() > 991) {
        $('.predictive-srch-wrapper').removeClass('search-active');
     }
  });
  $('body').on('input','.rightMenu .SearchForm input[name="q"], .search-form input[name="q"]',function(){
    console.log('hwlllo');
    var resWrapper = $('.predictive-srch-wrapper'), _this = $(this), q = $(this).val(), b = '&resources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=product_type,tag,title,variants.title,vendor,variants.sku';
    if(q != ''){
      resWrapper.addClass('search-active');
      $.ajax('/search/suggest.json?q=' + q + b,{
        type: 'GET',
        dataType: 'json', // added data type
        success: function(response) {
          $('[data-no-res]').remove();         
          if (response.resources.results.products.length != 0) {
            $('[data-predictive-products]').empty().append('<ul></ul>');
            var productSuggestions = response.resources.results.products;
            for( var i = 0; i < response.resources.results.products.length; i++){
              // if (productSuggestions[i]['available'] == true){
                var imgsrc = 'https://cdn.shopify.com/s/files/1/0710/5570/4352/files/no-image.png?v=1683802385', price = '', type = '', title = '', link = '', compare_at_price = 0;
                if (productSuggestions[i]['url'] != null) link = productSuggestions[i]['url'];
                if (productSuggestions[i]['title'] != null) title = productSuggestions[i]['title'];
                if (productSuggestions[i]['featured_image'].url != null) imgsrc = productSuggestions[i]['featured_image'].url;
                if (productSuggestions[i]['price'] != null) price = productSuggestions[i]['price'];
                if (productSuggestions[i]['compare_at_price_max'] != null) compare_at_price = productSuggestions[i]['compare_at_price_max'];
                if (productSuggestions[i]['type'] != null) type = productSuggestions[i]['type'];
                if (parseFloat(compare_at_price) > parseFloat(price)) {
                    var compareAtPriceFormatted = Shopify.formatMoney(compare_at_price * 100, window.mf);
                    var priceFormatted = Shopify.formatMoney(price * 100, window.mf);
                
                    compareAtPriceFormatted = compareAtPriceFormatted.replace('.00', '');
                    priceFormatted = priceFormatted.replace('.00', '');
                
                    var pr = '<span class="with_compare"><del>' + compareAtPriceFormatted + '</del> <span>' + priceFormatted + '</span></span>';
                } else {
                    var priceFormatted = Shopify.formatMoney(price * 100, window.mf);
                    priceFormatted = priceFormatted.replace('.00', '');
                
                    var pr = '<span>' + priceFormatted + '</span>';
                }

              console.log(pr);
                $('[data-predictive-products] ul').append("<li class='pre-product-card'><a href='"+ link + "'><div class='menu-card-img'><img src='"+ imgsrc +"' loading='lazy' alt='"+ title +"' /></div><div class='menu-card-details'><h3 class='pre-product-title'>"+ title +"</h3><span class='pre-product-type'>"+ type +"</span>"+ pr +"</div></a></li>");
                if (i==7) break;
              // }
            }
            $('.predictive-srch-right-wrapper').append('<p data-no-res class="product-res-all">Ver todos los productos <a href="/search?q='+ _this.val() +'&type=product"> a juego <strong>"'+ _this.val() +'"</strong></a> ('+productSuggestions.length+')</p>')
          } else {
            $('[data-predictive-products]').empty();
            $('.predictive-srch-right-wrapper').append('<div data-no-res class="no-product-res"><p>Sin resultado para la consulta "'+ _this.val() +'"</p><a href="/collections/all">Ver todos los productos</a>');
          }
  
          if (response.resources.results.collections.length != 0) {
            $('[data-predictive-collection]').empty().append('<ul></ul>');
            var collectionSuggestions = response.resources.results.collections;
            for( var i = 0; i<response.resources.results.collections.length; i++){
              var link = '', title = '';
              if (collectionSuggestions[i]['title'] != null) title = collectionSuggestions[i]['title'];
              if (collectionSuggestions[i]['handle'] != null) link = collectionSuggestions[i]['handle'];
              $('[data-predictive-collection] ul').append("<li><a href='/collections/" + link + "' > " + title + "</a></li>");
              if (i==3) break;
            }
          } else {
            $('[data-predictive-collection]').empty().html('<p data-no-res>No se encontraron sugerencias</p>');
          }
        }
      });
    } else {
      resWrapper.removeClass('search-active');
      setTimeout(function() {
        $('[data-predictive-collection], [data-predictive-products]').empty();
        $('[data-no-res]').remove();
      }, 500);
    }
  });
  // Predictive search end
  $('#shopify-section-footer a').each(function(){

    if($(this).html() == 'Accessibility Toolbar'){
      $(this).attr('id', 'accessibilityEnablerCustomTrigger');
    }

  });
    /* new product page start */

  function scroll_stick_add_to_cart(){
    if($('.cutsom_button').length > 0 && (window.location.href.indexOf('is_sticky_atc=true') > -1 || window.sticky_add_to_cart == true)){
      $(".cutsom_button").removeClass("is-visible").removeClass("ProductStickyAddToCart");
      var scroll = $(window).scrollTop();

      var elemTop = $('.cutsom_button').offset().top;
      var elemBottom = elemTop + $('.cutsom_button').height();

      if (scroll >= elemBottom) {
        $(".cutsom_button").addClass("is-visible").addClass("ProductStickyAddToCart");
        if($(window).width() < 769){
          $('body').css("padding-bottom",$('.cutsom_button').outerHeight()+"px");
        }
      }
    }
  }

  scroll_stick_add_to_cart();

  $(window).scroll(function() {    
    scroll_stick_add_to_cart();
  });

  $window = $(window);
  $slick_slider = $('.proImgClrGroup');
  settings = {
    centerMode: false,
    arrows: false,
    dots: true, 
    autoplay: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  
  if ($window.width() <= 991) {
    $slick_slider.slick(settings);
  }
  $window.on('resize load', function () {
    if ($window.width() > 991) {
      if ($slick_slider.hasClass('slick-initialized')) {
        $slick_slider.slick('unslick');
      }
    } else if (!$slick_slider.hasClass('slick-initialized')) {
      return $slick_slider.slick(settings);
    }
  });
  
  $('body').on("click",'.closeZoom', function(){
    closeZoom();
  });
  
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      closeZoom();
    }
  });
  
  var closeZoom = function () {
  $('.zoomImgsWrap').remove();
  $('body').removeClass('ovfHidden');
  $('.mainImg').removeClass('current');
}

  var pt = window.sm_theme.variable.product_title;
  $('.proImgClrGroup .featuredSlide .zoom_object').on("click",function(){
   
    $('.proImgClrGroup .featuredSlide .zoom_object').removeClass('current');
    $(this).addClass('current');
    $('body').addClass('ovfHidden');
    $('body').append('<div class="zoomImgsWrap"><div class="zoomimage_wrapper"><div class="zoomImgsCont"></div> <button class="closeZoom">X</button></div></div>');
    $(this).closest('.proImgClrGroup').find('.product-image:not(.slick-cloned) .zoom_object').each(function() {
      if ($(this).hasClass('type_image')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<img class="zoomTo zoom_element" src="'+$(this).attr('data-img')+'" alt="'+pt+'" />');
        else
          $('.zoomImgsCont').append('<img class="zoom_element" src="'+$(this).attr('data-img')+'" alt="'+pt+'" />');
      } else if ($(this).hasClass('type_video')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<video class="zoomTo zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
        else
          $('.zoomImgsCont').append('<video class="zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
      }
    });

    var imgs = $(".zoomImgsCont .zoom_element");
    var count = imgs.length;

    imgs.load(function() {
      count--;
      if (!count) {
        //setTimeout(function(){
        var s = $(".zoomImgsCont .zoom_element.zoomTo").position().top;
        $('.zoomImgsCont').animate({ scrollTop: s }, 1000);
        //},500);
      }
    }).filter(function() { return this.complete; }).load();

  });
  /* new product page end */

  var clickedBtn = false;
  $('.viewClDesc').on('click',function(e) {
    e.preventDefault();
    $(this).closest('.clItem').find('.clDesc').slideToggle();
    if ($(this).text() == 'Ver detalles') $(this).html('Ocultar detalles');
    else $(this).html('Ver detalles');
  });
  jQuery('.clSize').on('change',function() {
    var optionIndex = jQuery(this).closest('.clSw').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });
  if ($('body').hasClass('product') && $('.complete_the_look_grid').length > 1){
    var sortedDivs = jQuery(".completeLook").find(".complete_the_look_grid").toArray().sort(function(a, b){return parseInt(b.getAttribute('data-complte_price')) - parseInt(a.getAttribute('data-complte_price'))});
    jQuery.each(sortedDivs, function(index, value) {
      jQuery(".completeLook").append(value);
    });
    if ($('.complete_the_look_sale_grid').length > 0){
      var sortedDivs = jQuery(".completeLook").find(".complete_the_look_sale_grid").toArray().sort(function(a, b){return parseInt(b.getAttribute('data-complte_price')) - parseInt(a.getAttribute('data-complte_price'))});
      jQuery.each(sortedDivs, function(index, value) {
        jQuery(".completeLook").append(value);
      });
    }
  }
});

$(document).mouseup(function(e){
  var container = $('.inner_viral');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".viralsweep_popup").removeClass('open_viralpopup');
    $("body").removeClass('open_viralpopupbody');
    if($('#myVideo').length) {
      document.getElementById("myVideo").pause();
    }
  }
});
window.onload = function() {
  $('.full_banner').each(function(){
    var img = $(this).attr('data-banner');
    $(this).css('background-image','url('+img+')');
    $(this).find('img').attr('src',img);
  });
  if($(window).width() <= 991) {
    $('.afterLoad').each(function(){
      var img = $(this).attr('data-src');
      $(this).attr('src', img);
    });
  }
};


  
  

